import React from 'react';
import Moment from 'moment';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

const InsuredIdentitySummary = ({name, idNumber, dateOfBirth, phone}) => {
  const intl = useIntl();
  const items = [
    name,
    idNumber ? intl.formatMessage({id: 'identity.idNumber'}, {idNumber}) : null,
    dateOfBirth ? Moment(dateOfBirth).format('DD.MM.YYYY') : null,
    phone ? intl.formatMessage({id: 'identity.phone'}, {phone}) : null,
  ].filter(Boolean);

  return <p className='insured-issue-card__identity'>{items.join(' · ')}</p>;
};

InsuredIdentitySummary.propTypes = {
  dateOfBirth: PropTypes.string,
  idNumber: PropTypes.string,
  name: PropTypes.string,
  phone: PropTypes.string,
};

export default InsuredIdentitySummary;